import { useCallback, useRef, useState, type DragEvent, type PropsWithChildren } from 'react';
import { ACCEPT } from '../lib/files';
import { openFiles } from '../app/session';

export function DropZone({ children }: PropsWithChildren) {
  const [over, setOver] = useState(false);
  const input = useRef<HTMLInputElement>(null);
  const onDrop = useCallback((e: DragEvent) => {
    e.preventDefault(); setOver(false);
    void openFiles(Array.from(e.dataTransfer.files));
  }, []);
  return (
    <div className={`dropzone${over ? ' over' : ''}`} onDragOver={(e) => { e.preventDefault(); setOver(true); }} onDragLeave={() => setOver(false)} onDrop={onDrop}>
      <div className="drop-actions">
        <button className="primary" onClick={() => input.current?.click()}>Open files…</button>
        <input ref={input} type="file" accept={ACCEPT} multiple hidden onChange={(e) => { void openFiles(Array.from(e.target.files ?? [])); e.target.value = ''; }} />
        <span className="muted small">or drop PNG, PSD, JPG, WebP here</span>
      </div>
      {children}
      {over && <div className="drop-overlay">Drop to open</div>}
    </div>
  );
}
